import styled from 'styled-components';
import { Modal as ModalLib } from 'antd';

export const Modal = styled(ModalLib)``;